module.exports = __webpack_public_path__ + "static/aus_logo_colour-2-6ba228225e79910592b3c2af6aae45eb.png";